import axiosInstance from '../axiosInstance';

const getCommentsOfRequestAPI = (requestId) => {
    const url = `${import.meta.env.VITE_APP_APPLICATION_ENDPOINT}/request/${requestId}/comments`;
    return axiosInstance.get(url);
};
const addCommentAPI = async (requestId, comment) => {
    const url = `${import.meta.env.VITE_APP_APPLICATION_ENDPOINT}/request/${requestId}/comment`;
    return await axiosInstance.post(url, comment);
};

export default {
    getCommentsOfRequestAPI,
    addCommentAPI,
};
